import React from "react";
import { useTranslation } from "react-i18next";
import { Button, ButtonToolbar } from "react-bootstrap";
import { sanitize } from "../../formatters/Sanitize";

interface PaymentSuccessProps {
  onNext: () => void
}

export const PaymentSuccess = ({ onNext }: PaymentSuccessProps) => {
  const { t } = useTranslation()

  return (<>
    <div dangerouslySetInnerHTML={{ __html: sanitize(t("shoppingCart.paymentSuccess")) }} />
    <ButtonToolbar className="justify-content-between">
      <Button onClick={onNext}>{t("shoppingCart.continue")}</Button>
    </ButtonToolbar>
  </>)
}
